/**
 * Created by Nikita Besshaposhnikov on 18.12.14.
 */

/**
 * @class Layer for {@link pm.data.RepairMap}.
 * @implements SquarableMapLayerWithWalls
 */
var RepairMapLayer = SquarableMapLayerWithWalls.extend(/** @lends RepairMapLayer#*/{
	ctor: function(map)
	{
		this._super(map);
		this._orientation = pm.MapLayer2D.Orientation.Iso;
		this._mapElementSize = cc.size(64, 64);
	}
});
